import React from "react";
import { SiteContext } from "../contexts/SiteContext";
import { Link } from "react-router-dom";

function Banner() {
	const { selectedSite } = React.useContext(SiteContext);

	if (!selectedSite || !selectedSite.bannerImage) {
		return null;
	}

	if (selectedSite && selectedSite.bannerImage) {
		return (
			<div
				style={{
					maxWidth: process.env.REACT_APP_MAX_WIDTH,
					margin: "1rem auto 0 auto",
					padding: "0 1rem",
				}}
			>
				<Link to={`/${selectedSite.slug}`}>
					<img
						style={{ width: "100%" }}
						src={`${process.env.REACT_APP_FILE_URL}/${selectedSite.bannerImage.fileName}`}
						alt={`${selectedSite.name} banner`}
					/>
				</Link>
			</div>
		);
	}
}

export default Banner;
